// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wrapper[data-v-716ecd02]{padding-top:51px}.title[data-v-716ecd02]{font-size:22px;line-height:30px;font-family:SFProDisplay-Medium,sans-serif;margin-bottom:32px;margin-top:0}.mb-48[data-v-716ecd02]{margin-bottom:48px}", ""]);
// Exports
module.exports = exports;
